var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftMobile = function SvgGiftMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#6364F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.642 13.658c0-.801-.65-1.45-1.451-1.45h-2.477c.641-.633 1.051-1.462 1.051-2.482 0-1.257-.721-2.622-2.748-2.622-2.665 0-4.892 2.838-5.939 4.43-1.047-1.592-3.342-4.43-6.008-4.43-2.026 0-2.748 1.365-2.748 2.622 0 1.02.422 1.85 1.076 2.481H7.879c-.8 0-1.45.65-1.45 1.451v2.88c0 .808.655 1.463 1.463 1.463v9.443c0 .801.65 1.45 1.45 1.45h17.403c.802 0 1.451-.649 1.451-1.45v-9.443c.798 0 1.445-.648 1.445-1.446v-2.897Zm-5.625-5.103c.897 0 1.297.377 1.297 1.17 0 1.612-1.798 2.482-3.49 2.482h-2.456c1.031-1.531 2.845-3.652 4.65-3.652Zm-11.947 0c1.805 0 3.688 2.12 4.718 3.651h-2.456c-1.692 0-3.559-.891-3.559-2.503 0-.794.4-1.148 1.297-1.148Zm16.12 7.995h-9.43v-2.892h9.43v2.892ZM7.88 13.658h9.43v2.892H7.88v-2.892ZM9.342 18h7.967v9.443H9.343V18Zm17.403 9.443H18.76V18h7.986v9.443Z",
    fill: "#fff"
  })));
};
export default SvgGiftMobile;